export const selectSearchMarkup = (url: string) => ({
  '@context': 'https://schema.org',
  '@type': 'SearchAction',
  target: url,
  'query-input': 'required name=search_term_string', // Проверить URL поиска
});
